<div class="row">
  <div  class="col-6 mt-2">
    <app-material-input-checkbox [(ngModel)]="is_archive" [cssClass]="'mb-0'" [border]="true">
      В архиве
    </app-material-input-checkbox>
  </div>
  @if (!is_archive) {
    <div class="col-6 mt-2 d-flex flex-row-reverse">
      <button type="button" class="button button_sm" (click)="createNews()">
        Создать<span class="d-none d-md-inline"> акцию</span>
      </button>
    </div>
  }
</div>
@if (actions && actions.length && !is_archive) {
  <div class="mb-4 min-height-auto">
    <div class="wrapper" [ngStyle]="{'min-height' : position.length * rowHeight + 'px'}">
      @for (action of actions; track action; let i = $index) {
        <div class="wrapper__row_drag"
          ngDraggable
          [preventDefaultEvent]="true"
          [zIndexMoving]="'9999'"
          [trackPosition]="false"
          [position]="getPosition(i)"
          (movingOffset)="onMoving($event, i)"
          [handle]="sorthandle"
          >
          <div class="row-content">
            <div class="handle" #sorthandle>
              <i class="fa fa-th" aria-hidden="true"></i>
            </div>
            <div class="content-section">
              <div class="images-container">
                <div (click)="displayImage(action['icon'][0]['url'])" class="icon_block"
                  [style.background-image]="'url('+action['icon'][0]['url']+')'">
                </div>
                <div (click)="displayImage(action['banner'][0]['url'])" class="banner_block"
                  [style.background-image]="'url('+action['banner'][0]['url']+')'">
                </div>
              </div>
              <div class="text-content">
                <div class="title">{{action['title']}}</div>
                <div class="details text-muted">
                  <span>Создана: {{action['create_time']}}</span>
                  <span class="author-info">Автор: {{action['author']}}</span>
                  <span>Просмотров: {{action['views_count']}} (<a href="javascript: void(0)" (click)="modalViewsOpen(action)">подробнее</a>)</span>
                </div>
              </div>
            </div>
            <div class="actions-container">
              <div class="button button_icon" (click)="editAction(action)">
                <i class="fa fa-pencil"></i>
              </div>
              <div class="button button_icon" (click)="archiveAction(action['id'])">
                <i class="fa fa-trash"></i>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
@if (!is_archive) {
  <div class="col-6 mt-4 p-0">
    <button type="button" class="button button_sm" (click)="saveSorting()">
      Сохранить<span class="d-none d-md-inline"> сортировку</span>
    </button>
  </div>
}
@if (is_archive) {
  <div class="mt-2 p-0">
    <app-action-archive></app-action-archive>
  </div>
}

@if (modalViewsShow) {
  <app-modal [caption]="modalViewsCaption" (onClosed)="modalViewsClose()">
    <app-action-views-modal [id]="modalViewsActionId"></app-action-views-modal>
  </app-modal>
}
